import React, { useEffect } from "react";
import Header from "components/layout/Header";
import Disclaimer from "components/Disclaimer";
import SectionDownload from "components/SectionDownload";
import Footer from "components/layout/Footer";
import { connect } from "react-redux";
import { Creators as countriesActions } from "../../store/ducks/coutries";
import { Creators as eventsActions } from "../../store/ducks/events";
import { Creators as atheleteActions } from "../../store/ducks/athelete";
import { Creators as schollActions } from "../../store/ducks/school";
import { Creators as disclaimersActions } from "../../store/ducks/disclaimer";
import { scrollTo } from '../../helpers/generalHelpers';

import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
const AlertPaym = withReactContent(Swal);

const Home = ({
  requestCountriesOptions,
  requestEvents,
  countries,
  events,
  atheleteRequest,
  athelete,
  clearMessage,
  schoolRequest,
  schools,
  disclaimersRequestRegisterLeeds
}) => {
  useEffect(() => {
    requestCountriesOptions();
    requestEvents();
    schoolRequest();
  }, [requestCountriesOptions, schoolRequest]);
  useEffect(() => {
    if (athelete.error) {
      AlertPaym.fire({
        title: Array.isArray(athelete.error.errors)
          ? athelete.error.errors[0]
          : athelete.error.errors || athelete.error.message,
        icon: "error"
      }).then(() => {
        clearMessage();
      });
    }
    if (athelete.payload) {
      AlertPaym.fire({
        title: athelete.payload.message,
        icon: "success"
      }).then(() => {
        scrollTo(athelete.payload.scroll)
        clearMessage();
      });
    }
  }, [athelete]);
  return (
    <>
      <Header />
      <Disclaimer
        disclaimersRequestRegisterLeeds={disclaimersRequestRegisterLeeds}
        atheleteRequest={atheleteRequest}
        countries={countries}
        events={events.events}
        schools={schools}
      />
      <SectionDownload />
      <Footer />
    </>
  );
};
const mapDispatchToProps = dispatch => ({
  requestCountriesOptions: () => dispatch(countriesActions.countriesRequest()),
  requestEvents: () => dispatch(eventsActions.eventsRequest()),
  atheleteRequest: payload =>
    dispatch(atheleteActions.atheleteRequest(payload)),
  schoolRequest: () => dispatch(schollActions.schoolRequest()),
  disclaimersRequestRegisterLeeds: (payload) => dispatch(disclaimersActions.disclaimersRequest(payload)),
  clearMessage: () => dispatch(atheleteActions.atheleteClearMessage())
});
const mapStateToProps = state => ({
  countries: state.countries,
  events: state.events,
  athelete: state.athelete,
  schools: state.school
});

export default connect(mapStateToProps, mapDispatchToProps)(Home);
